// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4521d944","263":"0a6c22d8","361":"d93969f2","501":"fed146c2","525":"8efdf4f0","698":"5021acd5","760":"42633956","769":"33fb95ca"}[chunkId] + ".chunk.js";
};